import { connect } from 'react-redux';

import selectors from '../selectors';
import LoginWrapper from '../components/LoginWrapper';
import ClerkLoginWrapper from '../components/ClerkLoginWrapper';
import clerkConfig from '../config/clerk';

const mapStateToProps = (state) => {
  const isInitializing = selectors.selectIsInitializing(state);

  return {
    isInitializing,
  };
};

// Usar Clerk si está configurado, sino usar login tradicional
const WrappedComponent = clerkConfig.isConfigured() ? ClerkLoginWrapper : LoginWrapper;

export default connect(mapStateToProps)(WrappedComponent);
